import {
  type EffectRain,
  EffectRainType,
  type EffectSunlight,
  type HotspotEvents,
  type LensFlarePluginParams,
  type SceneEffect,
  type SnowPluginParams,
} from '@types';
import { MainPlayer } from '@stores/krpPlayerStores';
import { getMediaUrl, getSysUrl } from '@utils/urlMakers';
import { RAIN_TYPE_CONFIG, SUNLIGHT_DRAG_HANDLER } from '../constants';
import { isRainEffect, isSunlightEffect } from '../utils/effectTypeCheck';

const toRainEffectParams = (data: EffectRain): SnowPluginParams => {
  const { mediaId, type, mediaUrl, rainType, scale, ...rest } = data;
  if (rainType === EffectRainType.custom) {
    return {
      ...rest,
      mode: 'image',
      imageScale: scale,
      imageUrl: getMediaUrl(mediaUrl),
    };
  }
  return {
    ...rest,
    mode: 'image',
    imageUrl: getSysUrl(RAIN_TYPE_CONFIG[rainType].src),
    imageScale: scale,
  };
};

const toLensFlarePluginParams = (
  data: EffectSunlight
): LensFlarePluginParams => {
  const { type, ...rest } = data;
  return rest;
};

export function krpRemoveEffect(id: string) {
  MainPlayer.get()?.removePlugin(id);
}

export function krpAddRainEffect(data: EffectRain) {
  MainPlayer.get()?.addSnowPlugin(toRainEffectParams(data));
}

export function krpUpdateRainEffect(data: SnowPluginParams) {
  MainPlayer.get()?.updateSnowPlugin(data);
}

export function krpAddSunlight(data: EffectSunlight) {
  MainPlayer.get()?.addLensFlarePlugin(toLensFlarePluginParams(data));
}

export function krpUpdateSunlight(data: LensFlarePluginParams) {
  MainPlayer.get()?.updateLensFlarePlugin(data);
}

export function krpAddSunlightHandler(
  data: EffectSunlight,
  onMove: HotspotEvents['onHotspotMoving']
) {
  MainPlayer.get()?.addImageFrameHotspot({
    id: SUNLIGHT_DRAG_HANDLER,
    url: getSysUrl('/imgs/krp-sunlight.d823153212d27d5b25b6be89d004765d.png'),
    ath: data.ath,
    atv: data.atv,
    dragable: true,
    zOrder: 9999,
    frame: {
      frameWidth: 50,
      frameHeight: 50,
      frameCount: 2,
      frameDuration: 0.05,
    },
    events: {
      onHotspotMoving: onMove,
    },
  });
}

export function krpRemoveSunlightHandler() {
  MainPlayer.get()?.removeHotspotById(SUNLIGHT_DRAG_HANDLER);
}

export function krpAddEffect(data: SceneEffect) {
  if (isRainEffect(data)) {
    krpAddRainEffect(data);
  } else if (isSunlightEffect(data)) {
    krpAddSunlight(data);
  }
}
